<template>
  <div>
    <ViewTemplateConfiguration :templateList="templateList">
      <div slot="content-buttons">
        <Button _key="btnTypePaymentCreate" title="Tipo de Pagamento" classIcon="fas fa-plus-circle" type="primary"
          size="small" :clicked="create" />
      </div>
    </ViewTemplateConfiguration>
    <Modal title="Tipo de Pagamento" :width="500" :height="250" v-show="showModal('typePaymentCreateUpdate')">
      <TypePaymentCreateUpdate />
    </Modal>
  </div>
</template>

<script>
import ViewTemplateConfiguration from "@nixweb/nixloc-ui/src/component/template/ViewTemplateConfiguration";
import TypePaymentCreateUpdate from "@/components/modules/finance/type-payment/TypePaymentCreateUpdate.vue";

import Modal from "@nixweb/nixloc-ui/src/component/forms/Modal";
import Button from "@nixweb/nixloc-ui/src/component/forms/Button";

import { mapGetters, mapMutations } from "vuex";

export default {
  name: "TypePaymentView",
  components: {
    ViewTemplateConfiguration,
    Button,
    Modal,
    TypePaymentCreateUpdate,
  },
  data() {
    return {
      templateList: {
        urlGetApi: "/api/v1/finance/type-payment/get-all",
        urlDeleteAllApi: "/api/v1/finance/type-payment/delete",
        headerTable: [
          {
            field: "name",
            title: "Nome",
            type: "link",
            iconSearch: true,
            eventName: "typePaymentUpdate",
          },
          {
            field: "isBankSlipName",
            type: "text",
            iconSearch: false,
          },
        /*  {
            field: "moduleName",
            type: "text",
            iconSearch: false,
          },*/
        ],
      },
    };
  },
  computed: {
    ...mapGetters("generic", ["showModal", "event"]),
  },
  methods: {
    ...mapMutations("generic", ["addEvent", "openModal", "removeLoading"]),
    create() {
      this.openModal("typePaymentCreateUpdate");
      this.addEvent({ name: "typePaymentCreate" });
      this.removeLoading(["btnTypePaymentCreate"]);
    },
  },
  watch: {
    event: {
      handler(event) {
        if (event.name == "typePaymentUpdate")
          this.openModal("typePaymentCreateUpdate");
      },
      deep: true,
    },
  },
};
</script>
